module.exports = __webpack_public_path__ + "static/media/only_green_light.d2045ed3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/only_green_light.svg
// module id = 358
// module chunks = 0